import AbstractRepository from '@services/repositories/AbstractRepository';
import Cache from '@services/Cache';

export default class IconRepository extends AbstractRepository {
    constructor() {
        super();
        this.setApiUrl('/vue/product_icons');
    }

    async getAll() {
        if (Cache.get('product-icons')) {
            return Cache.get('product-icons');
        }

        return this.where('per_page', 1000).run().then((res) => {
            Cache.set('product-icons', res.data);
            return Cache.get('product-icons');
        });
    }
}
